import config from '@config'
import script from '@lib/script'

export const collectDlocalDeviceFingerprint = async (): Promise<string | null> => {
  try {
    await script.load(config.dlocal.deviceCollectorUrl)

    if (!(window as any).dlocalCollector) {
      return null
    }

    const eventUuid = await (window as any).dlocalCollector.create({
      ENV: config.dlocal.env,
      apiKey: config.dlocal.smartFieldKey,
    })

    return eventUuid
  } catch {
    return null
  }
}
